import React from 'react';
import { PageLayout } from './PageLayout';
import { Shield, Target, Users, Award, CheckCircle } from 'lucide-react';

const values = [
    {
        icon: Shield,
        title: 'Unabhängigkeit',
        description: 'Unsere Bewertungen werden nicht von Herstellern beeinflusst. Wir testen nach eigenen, objektiven Kriterien.'
    },
    {
        icon: Target,
        title: 'Transparenz',
        description: 'Wir legen offen, wie wir arbeiten und woher unsere Einnahmen stammen.'
    },
    {
        icon: Users,
        title: 'Verbraucherorientierung',
        description: 'Alles, was wir tun, dient dem Ziel, Verbrauchern bei ihrer Kaufentscheidung zu helfen.'
    },
    {
        icon: Award,
        title: 'Qualität',
        description: 'Wir setzen auf gründliche Recherche und regelmäßige Aktualisierung unserer Inhalte.'
    }
];

export const AboutPage = () => {
    return (
        <PageLayout title="Über uns">
            <div className="space-y-12">
                {/* Intro */}
                <section>
                    <h2 className="text-2xl font-semibold text-foreground mb-4">
                        Willkommen bei DetoxTeeTest
                    </h2>
                    <p className="text-muted-foreground leading-relaxed">
                        DetoxTeeTest.com ist Ihr unabhängiges Verbraucherportal für Detox-Tees und 
                        Kräutertees. Wir haben es uns zur Aufgabe gemacht, Ihnen objektive, umfassende 
                        und verständliche Informationen zu liefern, damit Sie die beste Kaufentscheidung 
                        treffen können.
                    </p>
                </section>

                {/* Mission */}
                <section>
                    <h2 className="text-2xl font-semibold text-foreground mb-4">
                        Unsere Mission
                    </h2>
                    <p className="text-muted-foreground leading-relaxed mb-4">
                        Der Markt für Detox-Tees ist vielfältig und oft unübersichtlich. Viele Produkte 
                        werben mit großen Versprechungen, doch was steckt wirklich dahinter? Genau hier 
                        setzen wir an.
                    </p>
                    <p className="text-muted-foreground leading-relaxed">
                        Wir analysieren Inhaltsstoffe, vergleichen Preise, prüfen Geschmacksprofile und 
                        bewerten die tatsächlichen Produkteigenschaften – immer mit dem Ziel, Ihnen eine 
                        fundierte Entscheidungsgrundlage zu bieten.
                    </p>
                </section>

                {/* How we work */}
                <section>
                    <h2 className="text-2xl font-semibold text-foreground mb-4">
                        So arbeiten wir
                    </h2>
                    <div className="space-y-4">
                        <div className="flex items-start gap-3">
                            <CheckCircle className="h-5 w-5 text-primary mt-1 flex-shrink-0" />
                            <p className="text-muted-foreground">
                                <strong className="text-foreground">Umfassende Recherche:</strong> Wir 
                                analysieren Produktdaten, Inhaltsstoffe und Kundenbewertungen aus 
                                verschiedenen Quellen.
                            </p>
                        </div>
                        <div className="flex items-start gap-3">
                            <CheckCircle className="h-5 w-5 text-primary mt-1 flex-shrink-0" />
                            <p className="text-muted-foreground">
                                <strong className="text-foreground">Objektive Bewertung:</strong> Unsere 
                                Bewertungskriterien sind klar definiert und für alle Produkte gleich.
                            </p>
                        </div>
                        <div className="flex items-start gap-3">
                            <CheckCircle className="h-5 w-5 text-primary mt-1 flex-shrink-0" />
                            <p className="text-muted-foreground">
                                <strong className="text-foreground">Regelmäßige Updates:</strong> Wir 
                                aktualisieren unsere Vergleiche regelmäßig, um stets aktuelle 
                                Informationen zu bieten.
                            </p>
                        </div>
                        <div className="flex items-start gap-3">
                            <CheckCircle className="h-5 w-5 text-primary mt-1 flex-shrink-0" />
                            <p className="text-muted-foreground">
                                <strong className="text-foreground">Transparente Finanzierung:</strong> Wir 
                                finanzieren uns über Affiliate-Partnerschaften – das beeinflusst jedoch 
                                nicht unsere Bewertungen.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Values */}
                <section>
                    <h2 className="text-2xl font-semibold text-foreground mb-6">
                        Unsere Werte
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {values.map((value, index) => (
                            <div 
                                key={index}
                                className="bg-secondary/50 rounded-lg p-6"
                            >
                                <div className="flex items-center gap-3 mb-3">
                                    <div className="p-2 bg-primary/10 rounded-lg">
                                        <value.icon className="h-5 w-5 text-primary" />
                                    </div>
                                    <h3 className="font-semibold text-foreground">{value.title}</h3>
                                </div>
                                <p className="text-sm text-muted-foreground">
                                    {value.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Disclaimer */}
                <section className="bg-muted/50 rounded-lg p-6">
                    <h3 className="font-semibold text-foreground mb-2">Wichtiger Hinweis</h3>
                    <p className="text-sm text-muted-foreground">
                        Unsere Vergleiche und Informationen dienen ausschließlich zu Informationszwecken 
                        und ersetzen keine medizinische Beratung. Bei gesundheitlichen Fragen wenden Sie 
                        sich bitte immer an einen qualifizierten Arzt oder Apotheker.
                    </p>
                </section>
            </div>
        </PageLayout>
    );
};

